import { FC, useCallback } from 'react'
import cn from 'classnames'
import { Icon } from '@/icons'

import styles from './ListViewToggle.module.scss'

export enum TypeOfView {
  Grid = 'GRID',
  List = 'LIST',
}

interface ListViewToggleProps {
  value: TypeOfView
  onChange: (value: TypeOfView) => void
}
export const ListViewToggle: FC<ListViewToggleProps> = ({
  value,
  onChange,
}) => {
  const toggleOnGridView = useCallback(() => {
    onChange(TypeOfView.Grid)
  }, [onChange])

  const toggleOnListView = useCallback(() => {
    onChange(TypeOfView.List)
  }, [onChange])

  return (
    <div className={styles.typeOfListView}>
      <button
        className={styles.typeOfListViewButton}
        onClick={toggleOnGridView}
      >
        <Icon
          name="gridView"
          className={cn(styles.typeOfListViewIcon, {
            [styles.isActive]: value === TypeOfView.Grid,
          })}
        />
      </button>
      <button
        className={styles.typeOfListViewButton}
        onClick={toggleOnListView}
      >
        <Icon
          name="list"
          className={cn(styles.typeOfListViewIcon, {
            [styles.isActive]: value === TypeOfView.List,
          })}
        />
      </button>
    </div>
  )
}
